// extracted by mini-css-extract-plugin
module.exports = {"svg":"_499a06","circle":"_a1787d","circular-animation":"_95b34b","primary":"_643361","secondary":"_e3d338"};